import { Box, Text } from '@wix/design-system';
import { FunctionComponent } from 'react';
import { ArticleSmallIcon } from '../../../../icons/ArticleSmallIcon';
import { GenAiArticleLink } from '../../../../types';
import Link from 'next/link';
import { DATA_HOOKS } from '../../../../dataHooks';
import { useTranslation } from '@wix/wix-i18n-config';
import css from './index.module.scss';

type MoreInfoArticlesProps = {
  moreInfoArticles: GenAiArticleLink[];
  onMoreInfoArticleClick: (index: number) => void;
};

export const MoreInfoArticles: FunctionComponent<MoreInfoArticlesProps> = ({
  moreInfoArticles, onMoreInfoArticleClick
}) => {
  const { t } = useTranslation();

  return (
    <Box dataHook={DATA_HOOKS.GEN_ANSWER_BASED_ON_ARTICLES} className={css.basedOnArticlesWrapper}>
      <Text className={css.readMore} size='small'>
        {t('search-results-page.gen-answer.read-more')}
      </Text>

      {moreInfoArticles.map((articleLink, index) => (
        <Link key={index} href={articleLink.articleURL} target="_blank"
          className={css.readMoreArticleLink}
          onClick={() => onMoreInfoArticleClick(index)}>
          <ArticleSmallIcon />
          <Text
            dataHook={DATA_HOOKS.GEN_ANSWER_SOURCE_ARTICLE}
            size="tiny"
            className={css.name}
          >
            {articleLink.articleName}
          </Text>
        </Link>
      ))}
    </Box>
  );
};
